import { FeatureAppLoader } from '@feature-hub/react';
import React from 'react';
import { useRouteMatch } from 'react-router';
import { appsCommonsJS, appsUMD } from '../../app-constants';
import {
  getFeatureAppName,
  ModelOverviewIntegratorOptions,
} from '../../create-options-from-query-params';
import {
  contentFeatureAppMap,
  getConfigsFeatureApp,
} from '../../feature-app-helpers';
import { Match, MatchModel } from './types';
import {
  FaContentServiceV1,
  Content,
} from '@volkswagen-onehub/fa-content-service';

interface Ngw6AppRender extends ModelOverviewIntegratorOptions {
  baseUrl?: string;
  isSsr?: boolean;
}
const Ngw6AppRender: React.FC<Ngw6AppRender> = ({
  baseUrl,
  isSsr,
  ...props
}) => {
  const match: Match<MatchModel> = useRouteMatch();
  const featureAppName = getFeatureAppName(match.params.appId);
  const featureAppConfig = getConfigsFeatureApp({
    ...props,
    featureAppName,
  });

  // Configure Showroom variable to execute apps that require it
  showroomEmulation();
  return (
    <FeatureAppLoader
      featureAppId={`ngw6fa-${featureAppName}`}
      baseUrl={baseUrl}
      src={appsUMD[featureAppName]}
      serverSrc={isSsr ? appsCommonsJS[featureAppName] : undefined}
      config={featureAppConfig}
      beforeCreate={({ featureServices }) => {
        const content: Content = contentFeatureAppMap[featureAppName];
        if (content) {
          (featureServices[
            'fa-content-service'
          ] as FaContentServiceV1).content = content;
        }
      }}
    />
  );
};

const showroomEmulation = () => {
  const vwa_d6_cms = {
    browserRegistry: {
      singletonInstances: {
        CarConfigurationService: {
          get: () => {
            return {
              category: 'private',
              carlineId: '31301',
              salesGroupId: '38940',
              trimName: 'S',
              modelYear: '2020',
              exteriorId: 'F14 0Q0Q',
              interiorId: 'F56     BG',
              buildabilityStatus: 'buildable',
              modelId: 'BW22VS',
            };
          },
        },
      },
    },
  };
  //@ts-ignore
  global.vwa_d6_cms = vwa_d6_cms;
};
export default Ngw6AppRender;
